import { useEffect, useState } from "react";
import {
  Select,
  Button as AntButton,
  Input,
  Table,
  Button,
  Modal,
  DatePicker,
  Radio,
  Form,
  Descriptions,
  InputNumber,
} from "antd";
import axios from "apis/axios.global";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useStyles from "./style";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import { MdExpandMore } from 'react-icons/md';
import DataTypeforTableCells from "../DataTypeforTableCells";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";

const { Option } = Select;

const RunTime = () => {
  const classes = useStyles();
  const { urlId } = useParams<{ urlId: any }>();
  const navigate = useNavigate();
  const location: any = useLocation();
  const [form] = Form.useForm();
    const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState<any>();
  const [newDataSource, setNewDataSource] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [title, setTitle] = useState();
  const [inputs, setInputs] = useState<any[]>([]);
  const [templateList, setTemplateList] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempColumn, setTempColumn] = useState<any>(null);
  const [clickedCell, setClickedCell] = useState({
    rowIndex: null,
    value: "",
    index: null,
  });
  const [selectedCellDatatypes, setSelectedCellDatatypes] =
    useState<any>(clickedCell);
  const [expanded, setExpanded] = useState(true);
  const [inputCount, setInputCount] = useState<any>(4);
  const [mode, setMode] = useState<any>(true);
  //----------consoles----------------

  console.log("selectedId22", selectedId);
  console.log("formData", formData);
  console.log("inputs", inputs);
  console.log("newDataSource", newDataSource);
  console.log("selectedId", selectedId);
  console.log("clickedCell", clickedCell);
  console.log("isModalOpen", isModalOpen);
  console.log("templateList", templateList);
  console.log("urlId", urlId);
  console.log("mode", mode)

  //---------useeffects-------------------

  useEffect(()=>{
    setMode(location?.state?.mode);
  },[location?.state?.mode])

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    if (selectedCellDatatypes) {
      const updatedDataSource = newDataSource?.map((row, rowIndex) => {
        if (rowIndex === selectedCellDatatypes.rowIndex) {
          const updatedCells = row?.cells?.map((cell: any, cellIndex: any) => {
            if (
              cell.value === selectedCellDatatypes.value &&
              cellIndex === selectedCellDatatypes.index
            ) {
              return {
                ...cell,
                datatype: selectedCellDatatypes.dataType,
                dataOptions: selectedCellDatatypes.dataOptions,
              };
            }
            return cell;
          });
          return { ...row, cells: updatedCells };
        }
        return row;
      });
      setNewDataSource(updatedDataSource);
    }
  }, [selectedCellDatatypes]);

  // Reset the values whenever clickedCell changes
  useEffect(() => {
    setSelectedCellDatatypes(clickedCell);
  }, [clickedCell]);

  //calling table Data from the api
  useEffect(() => {
    getTableData();
  }, [selectedId, urlId]);

  // Update formData when title changes
  useEffect(() => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      title,
    }));
  }, [title]);

  //---------------functions--------------------

  const getTemplates = async () => {
    const res = await axios.get(
      "api/auditchecksheet/getAuditChecksheetTemplates"
    );
    setTemplateList(res.data);
  };



  //--------update Data-----------------
  const updateData = async () => {
    const finalFormData = {
      ...formData,
      tableContent: newDataSource,
    };
    const response = await axios.patch(
      `/api/auditchecksheet/updateAuditChecksheetTemplate/${selectedId}`,
      finalFormData
    );
    navigate("/checksheet");
  };

  //----------to target and store the table cell value -------------
  const handleInputChangeValue = (
    rowIndex: any,
    columnName: any,
    newValue: any,
    type: any
  ) => {
    setNewDataSource((prevDataSource) => {
      const updatedDataSource = [...prevDataSource];
      // Locate the specific cell to update
      const cell = updatedDataSource[rowIndex].cells.find(
        (c: any) => c.columnName === columnName
      );
      if (cell) {
        if (type === "entityType") {
          cell.entityId = newValue;
        } else if (type === "range-min") {
          cell.min = newValue;
        } else if (type === "range-max") {
          cell.max = newValue;
        } else {
          cell.value = newValue;
        }
      }
      return updatedDataSource;
    });
  };

  //--------to get table Data from the api ------------
  const getTableData = async () => {
    try {
      const endpoint = urlId
        ? `api/auditchecksheet/getAuditChecksheetById/${urlId}`
        : `/api/auditchecksheet/getAuditChecksheetTemplateDetails/${selectedId}`;

      const result = await axios.get(endpoint);

      // Update formData
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        tableHeader: result?.data?.tableHeader,
        formHeaderTitle: result?.data?.formHeaderTitle,
        tableHeaderTitle: result?.data?.tableHeaderTitle,
        type :result?.data?.type,
      }));

      // Update title
      setTitle(result?.data?.title);

      // Update other states based on the presence of urlId
      if (urlId) {
        setNewDataSource(result?.data?.tableContentValues);
        setInputs(result?.data?.formHeaderContents);
        setInputCount(result?.data?.formLayout)
      } else {
        setNewDataSource(result?.data?.tableContent);
        setInputs(result?.data?.formHeader);
        setInputCount(result?.data?.formLayout)
      }
    } catch (error) {
      console.error("Error fetching table data", error);
      //  Handle the error accordingly, maybe set an error state or show a notification
    }
  };


    //--------final submit of data-----------
    const submitData = async () => {
      if(urlId && mode === false){
        const filteredInputs = inputs?.map((item) => {
          if (item.datatype === "entityType" || item.datatype === "appFields") {
            const { options, ...rest } = item;
            return {
              ...rest,
              valueId: uuidv4(),
            };
          } else {
            return {
              ...item,
              valueId: uuidv4(),
            };
          }
        });
        const filteredNewDataSource = newDataSource?.map((item) => {
          const updatedCells = item?.cells?.map((content: any) => {
            if (
              content.datatype === "entityType" ||
              content.datatype === "appFields"
            ) {
              const { options, ...rest } = content;
              return rest;
            }
            return content;
          });
          const updatedItem = {
            row: item.row,
            cells: updatedCells,
          };
          return updatedItem;
        });
       const finalFormData ={
        formHeaderContents: filteredInputs,
        tableContentValues: filteredNewDataSource,
       }
        const response = await axios.patch(
          `/api/auditchecksheet/updateAuditCheckSheet/${urlId}`,
          finalFormData
        );
       if(response.status === 200 || response.status ===201){
        enqueueSnackbar(`Updated successfully!`, {
          variant: "success",
        });
        navigate("/checksheet");
       }
      }else{
        const filteredInputs = inputs?.map((item) => {
          if (item.datatype === "entityType" || item.datatype === "appFields") {
            const { options, ...rest } = item;
            return {
              ...rest,
              valueId: uuidv4(),
            };
          } else {
            return {
              ...item,
              valueId: uuidv4(),
            };
          }
        });
        const filteredNewDataSource = newDataSource?.map((item) => {
          const updatedCells = item?.cells?.map((content: any) => {
            if (
              content.datatype === "entityType" ||
              content.datatype === "appFields"
            ) {
              const { options, ...rest } = content;
              return rest;
            }
            return content;
          });
          const updatedItem = {
            row: item.row,
            cells: updatedCells,
          };
          return updatedItem;
        });
        
        const finalFormData = {
          title:
            templateList.find((item: any) => item._id === selectedId).title +
            " - " +
            dayjs()?.format("DD/MM/YYYY HH:mm:ss"),
          auditChecksheetTemplateId: selectedId,
          formHeaderContents: filteredInputs,
          tableHeader: formData.tableHeader,
          tableContentValues: filteredNewDataSource,
          formHeaderTitle: formData.formHeaderTitle,
          tableHeaderTitle: formData.tableHeaderTitle,
          formLayout:inputCount,
          type:"new"
        };
        const response = await axios.post(
          `/api/auditchecksheet/createAuditChecksheet`,
          finalFormData
        );
        navigate("/checksheet");
      }
    };

  const handleOk = () => {
    setIsModalOpen(false);
    setClickedCell({
      rowIndex: null,
      value: "",
      index: null,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setClickedCell({
      rowIndex: null,
      value: "",
      index: null,
    });
  };

  const columns = formData?.tableHeader?.map((attr: any, index: any) => ({
    title: () => (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Input
            type="text"
            value={
              tempColumn && tempColumn.id === attr.id
                ? tempColumn.attributeName
                : attr.attributeName
            }
            onChange={(e) => {
              e.preventDefault();
              if (tempColumn && tempColumn.id === attr.id) {
                setTempColumn({ ...tempColumn, attributeName: e.target.value });
              } else {
                setTempColumn({ id: attr.id, attributeName: e.target.value });
              }
            }}
            placeholder="Enter column name"
            style={{ marginRight: "8px", width: "100%", color: "black" }}
            disabled={true}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {/* <div
              style={{
                width: "25px",
                height: "25px",
                border: "2px solid black",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "12px",
                backgroundColor: "#a7f1a7",
                fontWeight: "bold",
              }}
            >
              {attr.rowFieldType?.charAt(0).toUpperCase() === "N"
                ? "L"
                : attr.rowFieldType?.charAt(0).toUpperCase()}
            </div> */}
          </div>
        </div>
      </>
    ),
    dataIndex: attr.attributeName.toLowerCase().replace(/\s+/g, "_"),
    render: (text: any, record: any, rowIndex: any) => {
      const columnName = attr.attributeName;
      const cell = record.cells.find((c: any) => c.columnName === columnName);
      const specificationCell = record.cells.find(
        (c: any) => c.columnType === "specification"
      );
      const dataTypeSpecification = specificationCell
        ? specificationCell.datatype
        : "";
      const remarksCell = record.cells.find(
        (c: any) => c.columnType === "remarks"
      );
      const dataTypeRemaks = remarksCell ? remarksCell.datatype : "";
      return (
        <div style={{ display: "flex", gap: "10px" }}>
          {cell && cell.columnType === "value" ? (
            (() => {
              
              if (urlId && mode === true) {
                // if (dataType === "numberRange") {
                //   return (
                //     <div style={{ display: "flex", gap: "10px" }}>
                //       <Input
                //         value={cell.min}
                //         type="number"
                //         style={{ width: 90, color: "black" }}
                //         placeholder="Min"
                //         disabled={true}
                //       />
                //       <span>-</span>
                //       <Input
                //         value={cell.max}
                //         type="number"
                //         style={{ width: 90, color: "black" }}
                //         placeholder="Max"
                //         disabled={true}
                //       />
                //     </div>
                //   );
                // } else
                if (dataTypeSpecification === "currentDate") {
                  return (
                    <Input
                      value={formattedDate}
                      style={{ width: 200, color: "black" }}
                      disabled={true}
                    />
                  );
                } 
                else if (
                  dataTypeSpecification === "number" ||
                  dataTypeSpecification === "numberRange"
                ) {
                  const upperLimit =
                    specificationCell?.value +
                    Number(specificationCell?.toleranceValue?.max);
                  const lowerLimit =
                    specificationCell.value -
                    Number(specificationCell?.toleranceValue?.min);
                  const isInRange =
                    cell?.value >= lowerLimit && cell?.value <= upperLimit;
                  return (
                    <>
                      <Input
                        type="number"
                        value={cell.value}
                        onChange={(e) =>
                          handleInputChangeValue(
                            rowIndex,
                            columnName,
                            e.target.value,
                            "number"
                          )
                        }
                        style={{
                          width: 200,
                          color:"black",
                          border:
                            specificationCell.toleranceType === "tolerance" &&
                            cell.value
                              ? `${isInRange ? "1px solid #d9d9d9" : "2px solid red"}`
                              : "1px solid #d9d9d9",
                          backgroundColor:
                            specificationCell.toleranceType === "tolerance" &&
                            cell.value
                              ? isInRange
                                ? "rgba(0, 0, 0, 0.04)" // Light green (in range)
                                : "rgba(255, 0, 0, 0.1)" // Light red (out of range)
                              : "rgba(0, 0, 0, 0.04)", // Default background
                        }}
                        placeholder="Enter number"
                        disabled={true}
                      />
                    </>
                  );
                }else {
                  return (
                    <Input
                      value={cell.value}
                      style={{ color: "black" }}
                      disabled={true}
                    />
                  );
                }
              } else {
                if (dataTypeSpecification === "entityType") {
                  return (
                    <Select
                      style={{ width: 200,color:"black" }}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e,
                          "entityType"
                        )
                      }
                      disabled={mode}
                    >
                      {specificationCell?.options?.map((option: any) => (
                        <Option value={option.id}>{option.name}</Option>
                      ))}
                    </Select>
                  );
                } else if (dataTypeSpecification === "appFields") {
                  return (
                    <Select
                      style={{ width: 200,color:"black" }}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e,
                          "appFields"
                        )
                      }
                      disabled={location?.state?.mode}
                    >
                      {specificationCell?.options?.map((field: any) => (
                        <Option key={field} value={field}>
                          {field}
                        </Option>
                      ))}
                    </Select>
                  );
                } else if (dataTypeSpecification === "text") {
                  return (
                    <Input
                      value={cell.value}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e.target.value,
                          "text"
                        )
                      }
                      style={{ width: 200,color:"black" }}
                      placeholder="Enter text"
                      disabled={mode}
                    />
                  );
                } else if (
                  dataTypeSpecification === "number" ||
                  dataTypeSpecification === "numberRange"
                ) {
                  const upperLimit =
                    specificationCell?.value +
                    Number(specificationCell?.toleranceValue?.max);
                  const lowerLimit =
                    specificationCell.value -
                    Number(specificationCell?.toleranceValue?.min);
                  const isInRange =
                    cell?.value >= lowerLimit && cell?.value <= upperLimit;
                  return (
                    <>
                      <Input
                        type="number"
                        value={cell.value}
                        onChange={(e) =>
                          handleInputChangeValue(
                            rowIndex,
                            columnName,
                            e.target.value,
                            "number"
                          )
                        }
                        style={{
                          width: 200,
                          color:"black",
                          border:
                            specificationCell.toleranceType === "tolerance" &&
                            cell.value
                              ? `2px solid ${isInRange ? "#ccc" : "red"}`
                              : "1px solid #ccc",
                          backgroundColor:
                            specificationCell.toleranceType === "tolerance" &&
                            cell.value
                              ? isInRange
                                ? "transparent" // Light green (in range)
                                : "rgba(255, 0, 0, 0.1)" // Light red (out of range)
                              : "transparent", // Default background
                        }}
                        placeholder="Enter number"
                        disabled={mode}
                      />
                    </>
                  );
                }
                // else if (dataType === "numberRange") {
                //   return (
                //     <div style={{ display: "flex", gap: "10px" }}>
                //       <Input
                //         type="number"
                //         style={{ width: 90 }}
                //         placeholder="Min"
                //         onChange={(e) =>
                //           handleInputChangeValue(
                //             rowIndex,
                //             columnName,
                //             e.target.value,
                //             "range-min"
                //           )
                //         }
                //         disabled={urlId}
                //       />
                //       <span>-</span>
                //       <Input
                //         type="number"
                //         style={{ width: 90 }}
                //         placeholder="Max"
                //         onChange={(e) =>
                //           handleInputChangeValue(
                //             rowIndex,
                //             columnName,
                //             e.target.value,
                //             "range-max"
                //           )
                //         }
                //         disabled={urlId}
                //       />
                //     </div>
                //   );
                // }
                else if (dataTypeSpecification === "currentDate") {
                  return (
                    <Input
                      value={formattedDate}
                      style={{ width: 200, color: "black" }}
                      placeholder="Enter text"
                      disabled={true}
                    />
                  );
                } else if (dataTypeSpecification === "dateSelection") {
                  return (
                    <DatePicker
                      style={{ width: 200,color: "black" }}
                      format={"DD/MM/YYYY"}
                      onChange={(date, dateString) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          dateString,
                          "dateSelection"
                        )
                      }
                      disabled={mode}
                    />
                  );
                } else if (dataTypeSpecification === "multiValue") {
                  return (
                    <Select
                      style={{ width: 200,color: "black" }}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e,
                          "multiValue"
                        )
                      }
                      disabled={mode}
                    >
                      {specificationCell?.dataOptions?.map((field: any) => (
                        <Option key={field} value={field}>
                          {field}
                        </Option>
                      ))}
                    </Select>
                  );
                } else if (dataTypeSpecification === "yesNo") {
                  return (
                    <Radio.Group
                      style={{ width: 200,color: "black" }}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e.target.value,
                          "yesNo"
                        )
                      }
                      disabled={mode}
                    >
                      <Radio.Button value="yes">Yes</Radio.Button>
                      <Radio.Button value="no">No</Radio.Button>
                    </Radio.Group>
                  );
                } else {
                  return (
                    <Input
                      value={cell.value}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e.target.value,
                          "text"
                        )
                      }
                      style={{ width: 200,color: "black" }}
                      placeholder="Enter text"
                      disabled={mode}
                    />
                  );
                }
              }
            })()
          ) : cell &&
            cell.columnType === "specification" &&
            cell.datatype === "numberRange" ? (
            <>
              <Input
                type="number"
                value={cell?.minValue || ""}
                disabled={cell && cell.columnType !== "value"}
                style={{
                  color: "black",
                }}
              />
              _
              <Input
                type="number"
                value={cell?.maxValue || ""}
                disabled={cell && cell.columnType !== "value"}
                style={{
                  color: "black",
                }}
              />
              <span style={{ fontSize: "14px" }}>
                {specificationCell.dataOptions}
              </span>
            </>
          ) : cell && cell.columnType === "remarks" ? (
            (() => {
              if (urlId && mode === true) {
                return (
                  <Input
                    value={cell.value}
                    style={{ color: "black" }}
                    disabled={true}
                  />
                );
              } else {
                if (dataTypeRemaks === "text") {
                  return (
                    <Input
                      value={cell.value}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e.target.value,
                          "text"
                        )
                      }
                      style={{ width: 200, color:"black" }}
                      placeholder="Enter text"
                      disabled={mode}
                    />
                  );
                } else if (dataTypeRemaks === "yesNo") {
                  return (
                    <Radio.Group
                      style={{ width: 200, color:"black" }}
                      onChange={(e) =>
                        handleInputChangeValue(
                          rowIndex,
                          columnName,
                          e.target.value,
                          "yesNo"
                        )
                      }
                      disabled={mode}
                    >
                      <Radio.Button value="yes" style={{color: "black"}}>Yes</Radio.Button>
                      <Radio.Button value="no" style={{color: "black"}}>No</Radio.Button>
                    </Radio.Group>
                  );
                }
              }
            })()
          ) : (
            <>
              <Input
                value={cell ? cell.value : ""}
                disabled={cell && cell.columnType !== "value"}
                style={{
                  color: "black",
                }}
                suffix={
                  specificationCell &&
                (specificationCell.datatype === "number" ||
                  specificationCell.datatype === "numberRange") &&
                cell.columnType !== "None" &&
                cell.columnType !== "label" && (
                  <span style={{ fontSize: "14px" }}>
                    {specificationCell.dataOptions}{" "}
                    {specificationCell.toleranceType === "tolerance" &&
                      `(-${specificationCell?.toleranceValue?.min}/+${specificationCell?.toleranceValue?.max})`}
                  </span>
                )
                }
              />
              {/* {specificationCell &&
                (specificationCell.datatype === "number" ||
                  specificationCell.datatype === "numberRange") &&
                cell.columnType !== "None" &&
                cell.columnType !== "label" && (
                  <span style={{ fontSize: "14px" }}>
                    {specificationCell.dataOptions}{" "}
                    {specificationCell.toleranceType === "tolerance" &&
                      `( +${specificationCell?.toleranceValue?.max}, -${specificationCell?.toleranceValue?.min} )`}
                  </span>
                )} */}
            </>
          )}
        </div>
      );
    },
  }));

  const handleTemplateChange = (value: any) => {
    setSelectedId(value);
  };

  const handleFormHeaderChange = (e: any, index: any, type: any) => {
    // Create a copy of the inputs array to avoid mutating state directly
    const updatedInputs = [...inputs];

    // Add the new field 'value' to the specified index
    if (type === "entityType") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        entityId: e,
      };
    } else if (type === "appFields") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        value: e,
      };
    } else if (type === "range-min") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        min: e.target.value,
      };
    } else if (type === "range-max") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        max: e.target.value,
      };
    } else if (type === "dateSelection") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        value: e,
      };
    } else if (type === "multiValue") {
      updatedInputs[index] = {
        ...updatedInputs[index],
        value: e,
      };
    } else {
      updatedInputs[index] = {
        ...updatedInputs[index],
        value: e.target.value,
      };
    }

    // Set the updated inputs
    setInputs(updatedInputs);
  };

  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };

  const formattedDate = dayjs(new Date())?.isValid()
  ? dayjs(new Date())?.format("DD/MM/YYYY")
  : "";


  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          // padding: "20px",
          paddingTop:"10px"
        }}
      >
        {urlId ? (
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label
              style={{
                fontSize: "18px",
                color: "#003059",
                fontWeight: "bold",
              }}
            >
              Checksheet Title :{" "}
            </label>
            <p
              style={{
                fontSize: "18px",

                fontWeight: "bold",
              }}
            >
              {title}
            </p>
          </div>
        ) : (
          <div>
            <label
              style={{
                fontSize: "18px",
                color: "#003059",
                fontWeight: "bold",
              }}
            >
              Checksheet Templates :{" "}
            </label>
            <Select style={{ width: 220 }} onChange={handleTemplateChange}>
              {templateList?.map((option: any) => (
                <Option value={option._id} label={option.title}>
                  {option.title}
                </Option>
              ))}
            </Select>
          </div>
        )}

        <Button
          onClick={() => {
            navigate(-1);
          }}
          style={{
            backgroundColor: "#003059",
            color: "white",
            position: "absolute",
            right: "20px",
            margin: "15px",
          }}
        >
          Back
        </Button>
      </div>
      <Accordion
        style={{ marginTop: "20px" }}
        className={classes.headingRoot}
        expanded={expanded}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          expandIcon={<MdExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.summaryRoot}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography className={classes.heading}>
              {formData?.formHeaderTitle}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.headingRoot}>
          <div style={{ padding: "20px" }}>
           {urlId ? "" : <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <label
                style={{
                  color: "#003059",
                  fontWeight: "bold",
                }}
              >
                Form Field Alignment Layout  :{" "}
              </label>
              <div style={{display:"flex", alignItems:"center", gap:"3px"}}>
              <label
                style={{
                  color: "#003059",
                  fontWeight: "bold",
                  paddingLeft:"7px"
                }}
              >
               1 X
              </label>
              <InputNumber
                min={0}
                max={100}
                value={inputCount}
                onChange={(e)=>{
                  setInputCount(e);
                }}
                style={{ width: 60, marginLeft: "10px", color: "black" }}
                placeholder="Enter a number"
                disabled={urlId}
              />
              </div>
            </div> }
            <div >
              <div className={classes.descriptionLabelStyle}>
                <Form layout="vertical" form={form} >
                  <Descriptions
                    bordered
                    size="small"
                    column={{
                      xxl: inputCount,
                      xl: inputCount,
                      lg: inputCount,
                      md: 1,
                      sm: inputCount,
                      xs: inputCount,
                    }}
                  >
                    {inputs?.map((input, index) => (
                      // <div
                      //   key={index}
                      //   style={{
                      //     display: "flex",
                      //     marginBottom: 10,
                      //     flexDirection: "column",
                      //   }}
                      // >

                      <Descriptions.Item
                        label={
                          <>
                            <strong style={{ color: "red" }}>*</strong>{" "}
                            {input.attributeName}:{" "}
                          </>
                        }
                      >
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select a project type",
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          {(() => {
                            if (urlId && mode === true) {
                              if (input.datatype === "range") {
                                return (
                                  <div style={{ display: "flex", gap: "10px" }}>
                                    <Input
                                      value={input.min}
                                      type="number"
                                      style={{ width: 90, color: "black" }}
                                      placeholder="Min"
                                      disabled={true}
                                    />
                                    <span>-</span>
                                    <Input
                                      value={input.max}
                                      type="number"
                                      style={{ width: 90, color: "black" }}
                                      placeholder="Max"
                                      disabled={true}
                                    />
                                  </div>
                                );
                              } else if (input.datatype === "currentDate") {
                                return (
                                  <Input
                                    value={formattedDate}
                                    style={{ width: "100%", color: "black" }}
                                    placeholder="Enter text"
                                    disabled={true}
                                  />
                                );
                              } else {
                                return (
                                  <Input
                                    value={input.value}
                                    style={{ width: "100%", color: "black" }}
                                    placeholder="Enter text"
                                    disabled={true}
                                  />
                                );
                              }
                            } else {
                              if (input.datatype === "entityType") {
                                return (
                                  <Select
                                    style={{ width: "100%", color:"black" }}
                                    value={input.value}
                                    onChange={(e) =>
                                      handleFormHeaderChange(
                                        e,
                                        index,
                                        "entityType"
                                      )
                                    }
                                    disabled={mode}
                                  >
                                    {input?.options?.map((option: any) => (
                                      <Option key={option.id} value={option.id}>
                                        {option.name}
                                      </Option>
                                    ))}
                                  </Select>
                                );
                              } else if (input.datatype === "appFields") {
                                return (
                                  <Select
                                    style={{ width: "100%" , color:"black"}}
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(
                                        e,
                                        index,
                                        "appFields"
                                      )
                                    }
                                  >
                                    {input?.options?.map((field: any) => (
                                      <Option key={field} value={field}>
                                        {field}
                                      </Option>
                                    ))}
                                  </Select>
                                );
                              } else if (input.datatype === "text") {
                                return (
                                  <Input
                                    style={{ width: "100%", color:"black" }}
                                    placeholder="Enter text"
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(e, index, "text")
                                    }
                                  />
                                );
                              } else if (input.datatype === "number") {
                                return (
                                  <Input
                                    type="number"
                                    style={{ width: "100%", color:"black" }}
                                    placeholder="Enter number"
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(e, index, "number")
                                    }
                                  />
                                );
                              } else if (input.datatype === "range") {
                                return (
                                  <div style={{ display: "flex", gap: "10px" }}>
                                    <Input
                                      type="number"
                                      style={{ width: 90 }}
                                      placeholder="Min"
                                      value={input.min || ''}
                                      disabled={mode}
                                      onChange={(e) =>
                                        handleFormHeaderChange(
                                          e,
                                          index,
                                          "range-min"
                                        )
                                      }
                                    />
                                    <span>-</span>
                                    <Input
                                      type="number"
                                      style={{ width: 90 }}
                                      placeholder="Max"
                                      value={input.max || ''}
                                      disabled={mode}
                                      onChange={(e) =>
                                        handleFormHeaderChange(
                                          e,
                                          index,
                                          "range-max"
                                        )
                                      }
                                    />
                                  </div>
                                );
                              } else if (input.datatype === "currentDate") {
                                return (
                                  <Input
                                    value={formattedDate || ""}
                                    
                                    style={{ width: "100%", color: "black" }}
                                    placeholder="Enter text"
                                    disabled={true}
                                  />
                                );
                              } else if (input.datatype === "dateSelection") {
                                return (
                                  <DatePicker
                                    style={{ width: "100%", color:"black" }}
                                    value={input.value ? dayjs(input.value, "DD/MM/YYYY") : null}
                                    onChange={(date, dateString) =>
                                      handleFormHeaderChange(
                                        dateString,
                                        index,
                                        "dateSelection"
                                      )
                                    }
                                    disabled={mode}
                                    format={"DD/MM/YYYY"}
                                  />
                                );
                              } else if (input.datatype === "multiValue") {
                                return (
                                  <Select
                                    style={{ width: "100%", color:"black" }}
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(
                                        e,
                                        index,
                                        "multiValue"
                                      )
                                    }
                                  >
                                    {input?.dataOptions?.map((field: any) => (
                                      <Option key={field} value={field}>
                                        {field}
                                      </Option>
                                    ))}
                                  </Select>
                                );
                              } else if (input.datatype === "yesNo") {
                                return (
                                  <Radio.Group
                                    style={{ width: 200, color:"black" }}
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(e, index, "yesNo")
                                    }
                                  >
                                    <Radio.Button type="primary" value="yes">
                                      Yes
                                    </Radio.Button>
                                    <Radio.Button value="no">No</Radio.Button>
                                  </Radio.Group>
                                );
                              } else {
                                return (
                                  <Input
                                    style={{ width: "100%", color:"black" }}
                                    placeholder="Enter text"
                                    value={input.value}
                                    disabled={mode}
                                    onChange={(e) =>
                                      handleFormHeaderChange(e, index, "text")
                                    }
                                  />
                                );
                              }
                            }
                          })()}
                        </Form.Item>
                      </Descriptions.Item>

                      // </div>
                    ))}
                  </Descriptions>
                </Form>
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<MdExpandMore />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          className={classes.summaryRoot}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography className={classes.heading}>
              {formData?.tableHeaderTitle}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ flex: 1 }}>
              <div className={classes.tableContainer}>
                <Table
                  dataSource={newDataSource}
                  columns={columns}
                  pagination={false}
                  bordered
                  onRow={() => ({
                    onMouseEnter: (e) => {
                      const icon = e.currentTarget.querySelector(".info-icon");
                      if (icon) icon.style.visibility = "visible";
                    },
                    onMouseLeave: (e) => {
                      const icon = e.currentTarget.querySelector(".info-icon");
                      if (icon) icon.style.visibility = "hidden";
                    },
                  })}
                />
              </div>

              {formData?.tableHeader?.length > 0 ? (
                <div
                  style={{ display: "flex", gap: "20px", marginTop: "16px" }}
                >
                  <AntButton type="primary" onClick={submitData}>
                    Submit
                  </AntButton>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Modal
        title="Basic Modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <DataTypeforTableCells
          clickedCell={clickedCell}
          selectedCellDatatypes={selectedCellDatatypes}
          setSelectedCellDatatypes={setSelectedCellDatatypes}
        />
      </Modal>
      ;
    </>
  );
};

export default RunTime;
